import { render, staticRenderFns } from "./NumberFormatComponent.vue?vue&type=template&id=e7065b3e&"
import script from "./NumberFormatComponent.vue?vue&type=script&lang=js&"
export * from "./NumberFormatComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports